const surveyNavigatorScrollTrigger = () =>
{
    let isScrollFixed = false;
    const triggerPoint = 351;
    const $surveyNavigatorWrp = $('.survey-navigator__wrapper');
    const $surveyNavigator = $('.survey-navigator');
    if ($surveyNavigatorWrp.length === 0)
    {
        return;
    }

    const $window = $(window);
    const listenerHandler = () =>
    {
        if ($window.scrollTop() > triggerPoint)
        {
            if (!isScrollFixed)
            {
                isScrollFixed = true;
                $surveyNavigator.addClass('survey-navigator--fixed');
            }
        }
        else
        {
            if (isScrollFixed)
            {
                isScrollFixed = false;
                $surveyNavigator.removeClass('survey-navigator--fixed');
            }
        }
    };

    $window.on('scroll', listenerHandler);
    listenerHandler();

};

export { surveyNavigatorScrollTrigger }



// WEBPACK FOOTER //
// ./resources/assets/js/components/common/surveyNavigatorScrollTrigger.js